import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import { DataContext } from '../Componentes/DataContext';
import {toast, Toaster} from 'react-hot-toast';
import './ofertas.css';
import axios from 'axios';
import Logoicono from '../Componentes/logosvg2';
import regr from '../Componentes/regr.png';
import EditarOfertas from '../Componentes/EditarOfertas'

function Ofertas() {
    axios.defaults.withCredentials = true;
    const [radiosbuttons, setRadios] = useState({todia_juego: false, todia_res: false });
    const [OfCanchas, setOfCanchas] = useState({ });
    const [ChkOfertas, setChkOfertas] = useState({});
    const [inputsjue, setInputsjue] = useState({ });
    const [inputsres, setInputsres] = useState({ });
    const [inputs, setInputs] = useState({ });
    const [pruebares, setPruebares] = useState({ });
    const [active_pop, setActive_pop] = useState(false);
    const { ofertasData } = useContext(DataContext);
    const [canfut5, setCanfut5] = useState([]);
    const [canfut7, setCanfut7] = useState([]);
    const [canfut11, setCanfut11] = useState([]);
    const [allcan, setAllcan] = useState([])
    const stored = sessionStorage.getItem('ofertasArray');
    const ofertasData2 = stored ? JSON.parse(stored) : [];
    const [TipoOfer,  setTipoOfer] = useState('');
    const [UHora, setUHora] = useState(false);
    const [popUpof, setPopUpof] = useState( );
    const [UHinfo, setUHinfo] = useState({ });
    const [Uhora_chkbx, setUhora_chkbx] = useState({ });
    const [maxRows, setmaxRows] = useState( );
    const [DetOf,setDetOf] = useState({ })
    const [timer, setTimer] = useState(true);
    const [OfertasExistentes, setOfExistentes] = useState([ ]);
    const [OfActivas, SetOfActivas] = useState([ ])
    const [todosdetalles, setTodosdetalles] = useState([ ]);
    const [actionOf, setActionOf] = useState('');
    const [updt, setUpdt] = useState(false);


    useEffect(() => {
  async function initAll() {
    try {
      setCanfut5(ofertasData2.fut5);
      setCanfut7(ofertasData2.fut7);
      setCanfut11(ofertasData2.fut11);
      setAllcan([...ofertasData2.fut5, ...ofertasData2.fut7, ...ofertasData2.fut11]);

      const res = await axios.get(`${process.env.REACT_APP_HTTPS}/api/ofertas/getall`);
      const data = res.data;
      console.log(data);
      setOfExistentes(data.OfertasCreadas);
      SetOfActivas(data.OfertasActivas);

      if (data.UHOfertas.length > 0) {
        setDetOf(data.UHOfertas);
        const arreglo6 = {};
        let estadodi = false;

        for (const [ex, val] of Object.entries(data.UHOfertas)) {
          arreglo6[val.id_cancha] = { Precio: val.Precio, Estado: val.chkbx};
          const encontrado = [...ofertasData2.fut5, ...ofertasData2.fut7, ...ofertasData2.fut11]
            .find(allc => Number(allc.id) === val.id_cancha);           
            setUhora_chkbx((prev) => ({
                ...prev,
                [String('UHora_' + encontrado.Tipo)]: val.chkbx
            }));
          if (val.Estado === 1) {
            estadodi = true;
          }
        }
        setUHinfo(arreglo6);
        if (estadodi) {
          setUHora(true);
        }
      }      
    if (Object.entries(data?.OfertasActivas).length > 0) {
        for (const [ex, [val]] of Object.entries(data.OfertasActivas)) {
            if (val.estado === 1){
                setChkOfertas((prev) => ({
                    ...prev,
                    [ex]: true
                }));
            }
            if (val.estado === 0){
                setChkOfertas((prev) => ({
                    ...prev,
                    [ex]: false
                }));
            }
        }
    }

      setmaxRows(Math.max(ofertasData2.fut5.length, ofertasData2.fut7.length, ofertasData2.fut11.length));
    } catch (error) {
      console.error('Error in initAll:', error);
    } finally {
      setTimer(false);
    }
  }
  initAll();
  console.log('corrio el initall');
  

}, [updt]);

  //RadioButton Change
  const handleRadioChange = (e) => {
    setRadios((prev) => ({
            ...prev,
            ['tipo']: e.target.value
        }));
  };
  const handleRadioChange2 = (e) => {
    setRadios((prev) => ({
            ...prev,
            ['deposito']: e.target.value
        }));
  };
  const handleCanchas = (e) => {
    setOfCanchas((prev) => ({
            ...prev,
            [e.target.id]: e.target.checked 
        }));
  };
  const handleCanchas2 = (e) => {
    console.log(Uhora_chkbx);
    console.log(UHinfo);
    
    
    setUhora_chkbx((prev) => ({
            ...prev,
            [e.target.id]: e.target.checked
        }));
        
    if (e.target.id === 'UHora_5') {
        for (let i = 0; i < canfut5.length; i++) {
            const act = canfut5[i].id;
            console.log(UHinfo[act]);
            
            setUHinfo(prev => ({
                ...prev,
                [act]: {
                    ...prev[act],
                    Estado: e.target.checked ? 1 : 0
                }
            }));
        }        
    };
    if (e.target.id === 'UHora_7') {
        for (let i = 0; i < canfut7.length; i++) {
            const act = canfut7[i].id;
            setUHinfo(prev => ({
                ...prev,
                [act]: {
                    ...prev[act],
                    Estado: e.target.checked ? 1 : 0
                }
            }));
        }
    };
    if (e.target.id === 'UHora_11') {
        for (let i = 0; i < canfut11.length; i++) {
            const act = canfut11[i].id;
            setUHinfo(prev => ({
                ...prev,
                [act]: {
                    ...prev[act],
                    Estado: e.target.checked ? 1 : 0
                }
            }));
        }
    }
  };

    // Función para manejar el cambio de los checkboxes
    const handleCheckboxChange2 = async(acci) => {
        if (acci === 'solo'){
            console.log(Object.entries(UHinfo).length);
            if (Object.entries(UHinfo).length > 0) {
                console.log(UHinfo);
                setUHora(!UHora);
                await actualizarUH('valores');
            }
            else {
                toast("Ingrese los datos para la oferta de última hora.")
                setPopUpof(!popUpof);
            }
        }
        else if (acci === 'popup'){
            if (UHora === true){
                toast('Apague la oferta antes de cambiar');
                return;
            }
            setPopUpof(!popUpof);
        }
    };

    const crearOfUH = async () => {
        console.log('UH',UHinfo, 'CHK_Uh', Uhora_chkbx)
        const allFalse = Object.values(Uhora_chkbx).every(val => !val);
        if (Object.keys(Uhora_chkbx).length === 0 || allFalse) {
            toast.error('Seleccione un tipo de cancha.');
            console.log(Uhora_chkbx);
            return;
        }
        if (Object.entries(UHinfo).length < 1 ) {
            toast.error('Ingrese un precio.');
            return;
        }
        for (const [ex, val] of Object.entries(UHinfo)){
            console.log(val ,'Estado ', val.Estado, ' y Precio: ', val.Precio);            
            if (val.Estado === true || val.Estado === 1){
                console.log('Estado ',val.Estado, ' y Precio: ', val.Precio);
                if (val.Precio === '' || val.Precio === undefined) {
                    console.log(val.Precio);
                    toast.error('Ingrese un precio.');
                return;
                }
            }
        }
        await axios.post(`${process.env.REACT_APP_HTTPS}/api/ofertas/updateUH`, [{UHinfo}])
        .then((res)=> {
            if (res.data.success === true){
            setPopUpof(!popUpof);
            }
        });
        
    }

const actualizarUH = async () =>{
    const UHinfos = JSON.stringify(UHinfo);
    const OnOfUHof = JSON.stringify(!UHora);

    await axios.post(`${process.env.REACT_APP_HTTPS}/api/ofertas/toggleUH`, [{UHinfos, OnOfUHof}])
    .then((res) => {
        if (res.data.success === true && res.data.seted === true){  
            toast.success('Encendido', {
                iconTheme: {
                primary: 'green',
                secondary: '#fff',
            }});
        }
        else if (res.data.success === true && res.data.seted === false) {
            toast.success('Apagado', {
                iconTheme: {
                primary: 'red',
                secondary: '#fff',
            }});
        }
    })
}

const radiohandle = (e) => {
    const { id, checked } = e.target;
    setRadios((prev) => ({
        ...prev,
        [id]: checked,
    }));

    if (id === 'todia_res') {
        setInputsres((prev) => ({
            ...prev,
            horainires: checked ? null : '',
            horafinres: checked ? null : '',
        }));
    }
    if (id === 'todia_juego') {
        setInputsjue((prev) => ({
            ...prev,
            horainijue: checked ? null : '',
            horafinjue: checked ? null : '',
        }));
    }
};

    const capturarinput = (e) =>{
        setInputsres((prev) => ({
            ...prev,
            [e.target.id]: e.target.value
        }));
    }

    const capturarinput2 = (e) =>{
        setInputsjue((prev) => ({
            ...prev,
            [e.target.id]: e.target.value
        }));
    }

    const capturarinput3 = (e) =>{
        setInputs((prev) => ({
            ...prev,
            [e.target.id]: e.target.value
        }));
    }

    const ToggOf = async(e) => {
        try {
            const onof = e.target.checked;
            const idint = e.target.id;
            console.log(onof);
            await axios.post(`${process.env.REACT_APP_HTTPS}/api/ofertas/toggFecha`, [{id: idint, toggle: onof, action: 'Toggle'}])
            .then((res) => {                
                if (res.data.success === true && res.data.setted === true){
                    console.log(e.target.checked); 
                    setChkOfertas((prev) => ({
                        ...prev,
                        [idint]: onof
                    }));
                    toast.success('Encendido', {
                        iconTheme: {
                        primary: 'green',
                        secondary: '#fff',
                    }});
                }
                else if (res.data.success === true && res.data.setted === false) {
                    
                    toast.success('Apagado', {
                        iconTheme: {
                        primary: 'red',
                        secondary: '#fff',
                    }});
                    setChkOfertas((prev) => ({
                        ...prev,
                        [idint]: onof
                    }));
                }
            });
            setUpdt(!updt);
        } catch (error) {
            window.alert('Error en toggle ofertas por fecha')
        }
    }  

    const cinUHof = (e) =>{        
        setUHinfo(prev => ({
            ...prev,
            [e.target.id]: {... prev[e.target.id], Precio: e.target.value}
        }));
    }

    const crearoferta = async(act) =>{
        try {
            const camposValidos = [
            inputs.nombre,
            inputs.numero,
            inputs.deposito,
            inputs.normas,
            inputsres.fechinires,
            inputsres.fechfinres,
            inputsres.horainires,
            inputsres.horafinres,
            inputsjue.fechinijue,
            inputsjue.fechfinjue,
            inputsjue.horainijue,
            inputsjue.horafinjue
            ].every(campo => campo === null || (campo !== undefined && campo.toString().trim() !== ''));
            const canchasSeleccionadas = Object.values(OfCanchas).some(v => v);
            
            if (!camposValidos || !canchasSeleccionadas) {
                toast.error('Completa todos los campos y selecciona al menos una cancha');
                return;
            }
            switch (act) {
                case 'crear':
                    setActive_pop(true);
                    break;
                case 'confirmar':
                    setTimer(true)
                    await axios.post(`${process.env.REACT_APP_HTTPS}/api/ofertas/insertoferta`, [{inputs, inputsres, inputsjue, radiosbuttons, OfCanchas}])
                    .then((res)=>{
                        console.log(res.data);
                        setActive_pop(false);
                        setTipoOfer(false);
                        setInputs({});
                        setInputsjue({});
                        setInputsres({});
                        setRadios({todia_juego: false, todia_res: false });
                        setOfCanchas({});
                    }).finally(() =>{ 
                        setTimer(false);
                        toast.success('Oferta creada y activada correctamente', {
                        iconTheme: {
                        primary: 'green',
                        secondary: '#fff',
                        duration: 5000
                        }});
                        setUpdt(!updt);
                    }).catch((error) => {
                        if (error) {
                            console.error(error);
                        }
                    });
                    break;
            
                default:
                    break;
            }
            
        } catch (error) {
            console.error(error);
        }
    };
    const formatearISO = (date) => {
        const formateado =  new Date(`${date}T00:00:00`).toLocaleDateString('es-ES', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
            });
            return (formateado);
    };
    const fechas = async() => {
        const a = formatearISO(inputsres.fechinires);
        const b = formatearISO(inputsres.fechfinres); 
        const c = formatearISO(inputsjue.fechinijue); 
        const d = formatearISO(inputsjue.fechfinjue);
        setFechasformateadas({a: a, b:b, c:c, d:d})
    }
    const [fechasformateadas, setFechasformateadas] = useState({ });
        
    const [compra, setCompra] = useState(false);
    const [reserva, setReserva] = useState(false);

    const indicadores = () => {
        const [h1, h12] = inputsres.horainires.split(':').map(Number);
        const comp_bot = new Date(inputsres.fechinires).setHours(h1, h12);
        const [h2, h22] = inputsres.horafinres.split(':').map(Number);
        const comp_top = new Date(inputsres.fechfinres).setHours(h2, h22);
        const [h3, h32] = pruebares.horacompra.split(':').map(Number);
        const comp = new Date(pruebares.fechacompra).setHours(h3, h32);
        if (comp_bot < comp && comp_top > comp){
            const hoy_bot = new Date(pruebares.fechacompra).setHours(h1,h12,0,0);
            const hoy_top = new Date(pruebares.fechacompra).setHours(h2,h22,0,0);   
            if(hoy_bot < comp && comp < hoy_top){
                setCompra(true);
                console.log('entra en fecha y hora')
            } else{setCompra(false)}               
        }
    }

    const actbutton = (id, activas, act) =>{
        if (ChkOfertas[id] === true) {
                toast('Apague la oferta antes de editar');
                return
            } 
        if (act === 'editar') {
            const aenviar = OfertasExistentes.find((dat) => Number(dat.id) === Number(id));
            setTodosdetalles({aenviar, activas})
            setActionOf('editar')
        } else if (act === 'eliminar'){
            setActionOf('eliminar')
            setTodosdetalles(id);
        }        
    };

    
    const toggedit = () => {
        setActionOf('');
        setUpdt(!updt);
    }

  return (
    <div className='contenedor_of'>
        {timer ? (<div className='cargando'>
              <div className='logocargando'><Logoicono/></div>
            </div>):null}
        <Toaster />
        <EditarOfertas act={actionOf} toggle={toggedit} alldet={todosdetalles} todcanchas={{fut5: canfut5, fut7: canfut7, fut11: canfut11}}/>
        {active_pop ? ( 
        <div className='popup_oferta'>  
        <div><div id='back-button' onClick={() => setActive_pop(false)}><img src={regr} id="regresar" alt="Regresar"/></div>
            <h2>Revisa la oferta antes de crearla</h2><br/>
            <p>Estas seguro de crear la oferta <b>{inputs.nombre}</b> {radiosbuttons.tipo === 'fijo' ? (<> que costara <b>Q {inputs.numero}</b></>): 
                radiosbuttons.tipo === 'porcentaje' ? (<> del <b>{inputs.numero} %</b> </>) : (<>Precio: </>)} requiriendo un deposito {radiosbuttons.deposito === 'mismo' ? 
                    (<><b>igual</b> al que tiene la cancha por defecto </>): radiosbuttons.deposito === 'nuevo' ? (<> de <b>Q {inputs.deposito} </b></>) : radiosbuttons.deposito === 'porcentaje' ? 
                    (<>correspondiente al de <b>{inputs.deposito}% </b> del precio total</>): null
                } 
            , que aplicara para cuando se RESERVA entre las fechas: <b>{fechasformateadas.a}, </b> y <b>{fechasformateadas.b}</b>, {radiosbuttons.todia_res ? 
            (<b> a cualquier hora </b>) : (<>entre las horas <b>{inputsres.horainires}</b> y <b> {inputsres.horafinres}</b></>)}. En cuanto la FECHA DE JUEGO sea 
            entre las fechas <b>{fechasformateadas.c}</b> y <b>{fechasformateadas.d}</b>  
            {radiosbuttons.todia_juego ? (<b> a cualquier hora </b>) : (<> entre las horas <b>{inputsjue.horainijue}</b> y <b> {inputsjue.horafinjue}</b></>)}. 
            <br/><br/>Teniendo las siguientes normas:</p>            
                <div style={{marginLeft: '20px', whiteSpace: 'pre-line'}}>{inputs.normas}</div>            
            <br/><p>Esta oferta estara disponible para las canchas:</p>
            {Object.entries(OfCanchas).map(([key, value], index) => {
                const mostrar = allcan.find((cancha) => cancha.id === key);
                return value ? (
                    <li key={index} style={{textIndent: '5px'}}>
                        {mostrar.nombre} de fútbol <b>{mostrar.Tipo}</b>
                    </li>
                ) : null;}
            )}<br/>
            <div style={{display:'flex'}}><button onClick={() => crearoferta('confirmar')} className='crear_of'>Confirmar</button></div>
        </div></div>):null}

        <div className='input_of'>
            <h2 style={{margin: 'auto'}}>¿Qué tipo de oferta quieres crear?</h2>
            <div className={UHora ? 'ActivUHora_on': 'ActivUHora'}>
                <p>Activar oferta de última hora</p>
                <div className='div_switch_of'><label className="switch_of">
                    <input type='checkbox' onChange={() => handleCheckboxChange2('solo')} checked={UHora}/>
                    <span className="slider_of"></span>
                </label><br/>
                <button className='ChngOfertabtn' onClick={()=> handleCheckboxChange2('popup')}>Cambiar oferta</button><br/>
                <div className='OF_tbUH'>
                    <br/>
                    <h3>Oferta a activar:</h3>
                    {Uhora_chkbx.UHora_5 ? (<>{Object.entries(canfut5).map(([keys,vals], i) => {
                        return (<> {UHinfo[canfut5[i].id].Estado ? (<p key={i}> Fut {vals.Tipo} | {vals.nombre} | Precio = Q{UHinfo[canfut5[i].id]?.Precio}</p>) 
                        : null}    
                        </>)
                    })}</>):null}
                    {Uhora_chkbx.UHora_7 ? (<>{Object.entries(canfut7).map(([keys,vals], i) => {
                        return (<>{UHinfo[canfut7[i].id].Estado ? (<p key={i}> Fut {vals.Tipo} | {vals.nombre} | Precio = Q{UHinfo[canfut7[i].id]?.Precio}</p>)
                        : null}
                        </>)
                    })}</>):null}
                    {Uhora_chkbx.UHora_11 ? (<>{Object.entries(canfut11).map(([keys,vals], i) => {
                        return (<>{UHinfo[canfut11[i].id].Estado ? (<p key={i}> Fut {vals.Tipo} | {vals.nombre} | Precio = Q{UHinfo[canfut11[i].id]?.Precio}</p>)
                        : null}
                        </>)
                    })}</>):null}
                </div></div>
            </div>
            <div className='ActivCrearOf'>
                <button onClick={() => setTipoOfer(!TipoOfer)} className={TipoOfer ? 'crearporfecha-activo':null}>Crear oferta por fecha</button>
            </div>
        </div>

        {TipoOfer ? (<>
        <div className='input_ofb'>
            <div className='datos_oferta'><div className='inputsOfertas'>
                <label><b>Nombre de la oferta: </b><input type='text' className='nombre_oferta' onChange={capturarinput3} id='nombre' value={inputs.nombre}/></label><br/>
                <label><b>Tipo de oferta:</b></label>
                <form className='Of_F_radio'>
                    <label><input type='radio' onChange={handleRadioChange} value='porcentaje' checked={radiosbuttons.tipo === 'porcentaje'}/> Descuento general </label>
                    <label><input type='radio' onChange={handleRadioChange} value='fijo' checked={radiosbuttons.tipo === 'fijo'}/> Precio fijo </label>
                </form>
                <label><b>{radiosbuttons.tipo === 'fijo' ? (<>Precio: </>): 
                radiosbuttons.tipo === 'porcentaje' ? (<>Porcentaje: </>) : (<>Precio: </>)} </b><input type='number' className='numero' onChange={capturarinput3} id='numero' value={inputs.numero}
                disabled={radiosbuttons.tipo ? false : true}/></label><br/>
                <label><b>Depósito: </b>
                    <form className='Of_f_deposito'>
                        <label><input type='radio' onChange={handleRadioChange2} value='mismo' checked={radiosbuttons.deposito === 'mismo'}/> Mantener </label>
                        <label><input type='radio' onChange={handleRadioChange2} value='nuevo' checked={radiosbuttons.deposito === 'nuevo'}/> Nuevo </label>
                        <label><input type='radio' onChange={handleRadioChange2} value='porcentaje' checked={radiosbuttons.deposito === 'porcentaje'}/> % del total </label>
                    </form>
                    <input type='number' className='deposito_oferta' onChange={capturarinput3} id='deposito' value={inputs.deposito}
                    disabled={radiosbuttons.deposito ? (radiosbuttons.deposito === 'mismo' ? true : false) : true}/>
                </label><br/>
                <label><b>Normas: </b><textarea type='text' className='normas_oferta' onChange={capturarinput3} id='normas' value={inputs.normas}/></label>
                </div>
                <div className='oferta_selcan'>
                    <div style={{width: '100%', textAlign: 'center'}}><br/>
                        <h3>Seleccione las canchas a las que aplicara la oferta</h3>
                        <p>Tome en cuenta que si se selecciona <b>Precio fijo</b> el precio colocado aplicara de igual manera para todas las canchas seleccionadas.</p>
                    </div>
                    {canfut5.length > 0 ? (<>
                        <div className='chk_f5'>
                            <h4>Canchas de Fut 5</h4>
                            {canfut5?.map((can,i)=>(
                            <label key={i}> {can.nombre} 
                                <input key={i} input type='checkbox' id={can.id} checked={OfCanchas[can.id]} onChange={handleCanchas}/>
                            </label>
                            ))}
                        </div>
                    </>):null}
                    {canfut7.length > 0 ? (<>
                        <div className='chk_f7'>
                            <h4>Canchas de Fut 7</h4>
                            {canfut7?.map((can,i)=>(
                            <label key={i}> {can.nombre} 
                                <input key={i} input type='checkbox' id={can.id} checked={OfCanchas[can.id]} onChange={handleCanchas}/>
                            </label>
                            ))}
                        </div>
                    </>):null}
                    {canfut11.length > 0 ? (<>
                        <div className='chk_f11'>
                            <h4>Canchas de Fut 11</h4>
                            {canfut11?.map((can,i)=>(
                            <label key={i}> {can.nombre} 
                                <input key={i} input type='checkbox' id={can.id} checked={OfCanchas[can.id]} onChange={handleCanchas}/>
                            </label>
                            ))}
                        </div>
                    </>):null}
                </div>
            </div>
            <div><br/>
                <h3>Realización de la reserva</h3>
                <label>Fecha Inicio: <input type='date' className='fechini' onChange={capturarinput} id='fechinires' value={inputsres.fechinires}/></label>
                <label>Fecha Finalización: <input type='date' className='fechfin' onChange={capturarinput} id='fechfinres' value={inputsres.fechfinres}/></label>
                <label>Hora Inicio: <input type='time' className='horaini' onChange={capturarinput} id='horainires' value={inputsres.horainires} disabled={radiosbuttons.todia_res}/></label>
                <label>Hora Finalización: <input type='time' className='horafin' onChange={capturarinput} id='horafinres' value={inputsres.horafinres} disabled={radiosbuttons.todia_res}/></label>
                <label>Todo el dia <input type='checkbox' onChange={radiohandle} checked={radiosbuttons.todia_res} id='todia_res'/></label>
                <br/>
            </div>
            <div>
                <h3>Tiempo de juego</h3>
                <label>Fecha Inicio: <input type='date' className='fechini' onChange={capturarinput2} id='fechinijue' value={inputsjue.fechinijue}/></label>
                <label>Fecha Finalización: <input type='date' className='fechfin' onChange={capturarinput2} id='fechfinjue' value={inputsjue.fechfinjue}/></label>
                <label>Hora Inicio: <input type='time' className='horaini' onChange={capturarinput2} id='horainijue' value={inputsjue.horainijue} disabled={radiosbuttons.todia_juego}/></label>
                <label>Hora Finalización: <input type='time' className='horafin' onChange={capturarinput2} id='horafinjue' value={inputsjue.horafinjue} disabled={radiosbuttons.todia_juego}/></label>
                <label>Todo el dia <input type='checkbox' onChange={radiohandle} checked={radiosbuttons.todia_juego} id='todia_juego'/></label>
                <br/>
            </div>
            <button onClick={() => {crearoferta('crear'), fechas()}} className='crear_of'>Crear</button>
        </div>
        </>): null}

        {/** <div className='resultados_of'>
            <h1>Resultados</h1>
            <div>
                <h3>Informacion de la oferta:</h3>
                {Object.entries(inputs).map(([key,value], index) => (
                    <p key={index}>
                        {key}: {String(value)}
                    </p>
                ))}
                <h3>Radiobuttons:</h3>
                {Object.entries(radiosbuttons).map(([key,value], index) => (
                    <p key={index}>
                        {key}: {String(value)}
                    </p>
                ))}
                <h3>Canchas seleccionadas:</h3>
                {Object.entries(OfCanchas).map(([key,value], index) => (
                    <p key={index}>
                        {key}: {String(value)}
                    </p>
                ))}
                <h3>Inputs realizacion de la reserva:</h3>
                {Object.entries(inputsres).map(([key,value], index) => (
                    <p key={index}>
                        {key}: {String(value)}
                    </p>
                ))}
                <h3>Inputs tiempo de juego:</h3>
                {Object.entries(inputsjue).map(([key,value], index) => (
                    <p key={index}>
                        {key}: {String(value)}
                    </p>
                ))}
            </div>
        </div>
        <div className='prueba_compra'>
            <div className='inputs_horacompra'>
                <h2>Hora de compra</h2>
                <label>Fecha: <input type='date' onChange={capturarinput4} id='fechacompra' value={pruebares.fechacompra}/></label>
                <label>Hora: <input type='time' onChange={capturarinput4} id='horacompra' value={pruebares.horacompra}/></label>    
            </div>
            <div className='inputs_horareserva'>
                <h2>Hora de reserva</h2>
                <label>Fecha: <input type='date' onChange={capturarinput4} id='fechareserva' value={pruebares.fechareserva}/></label>
                <label>Hora: <input type='time' onChange={capturarinput4} id='horareserva' value={pruebares.horareserva}/></label>    
            </div>
            <div className='indicadores'>
                <div className={compra ? 'comp_tru' : 'comp_fal'}>Hora de compra</div>
                <div className={reserva ? 'comp_fal' : 'res_fal'}>Hora de reserva</div>
                <button className='comprobar_res' onClick={indicadores}>Comprobar</button>
            </div>
        </div>*/}
        <div className='OfertasExistentes'>
            <div className="ofertas-container">
            {OfertasExistentes.length === 0 ?(<div>
                        <h1 style={{textAlign: "center"}}>Aún no hay ofertas creadas</h1>
                    </div>): (<h2 style={{textAlign: "center"}}>Ofertas creadas</h2>)}
            {OfertasExistentes.map((item, index) => {
                let CanchasActivas = [];
                let claseactivo = false;
                if (OfActivas[item.id].length > 0){
                    for (const ofe of OfActivas[item.id]){
                        claseactivo = OfActivas[item.id].some(ofe => ofe.estado === 1);
                        const encon = allcan.find((cancha) => Number(cancha.id) === Number(ofe.id_cancha));
                        CanchasActivas.push({id: encon.id, nombre: encon.nombre, tipo: encon.Tipo});
                    }
                }
                return (<div
                key={item.id}
                className="oferta-card"
                style={claseactivo ? { animationDelay: `${index * 0.2}s`, backgroundColor: '#56b676', transition:'1s'} : {animationDelay: `${index * 0.2}s`, transition:'1s'}}
                >
                <h3>{item.nombre}</h3>
                <div>
                    <p><strong>Tipo:</strong> {item.tipo}</p>
                    <p><strong>Valor:</strong> {item.numero}</p>
                    <p><strong>Depósito:</strong> {item.tipoDeposito} - {item.deposito}</p>
                    <p><strong>Fecha de reserva:</strong> {new Date(item.res_fechainicio).toLocaleDateString('es-ES')} - {new Date(item.res_fechafin).toLocaleDateString('es-ES')}</p>
                    <p><strong>Hora de reserva:</strong> {item.res_horainicio} - {item.res_horafin}</p>
                    <p><strong>Fecha de juego:</strong> {new Date(item.jue_fechainicio).toLocaleDateString('es-ES')} - {new Date(item.jue_fechafin).toLocaleDateString('es-ES')}</p>
                    <p><strong>Hora de juego:</strong> {item.jue_horainicio} - {item.jue_horafin}</p>
                    <p style={{whiteSpace: "pre-line"}}><b>Normas:</b> {item.normas}</p>
                    <b>Canchas que aplican:</b>{Object.values(CanchasActivas).map((infocan, i) => {
                    return(<p style={{marginLeft: '20px'}} key={i}><b>{infocan.nombre}</b> de fútbol <b>{infocan.tipo}</b><br/></p>) 
                    })}
                </div>
                <div className='swich_oftoggle'>
                    <label className="switch_of">
                        <input type='checkbox' onChange={ToggOf} id={item.id} checked={ChkOfertas[item.id]}/>
                        <span className="slider_of"></span>
                    </label><br/>
                    <button onClick={() => actbutton(item.id, CanchasActivas, 'editar')}>Editar</button><br/>
                    <button onClick={() => actbutton(item.id, {}, 'eliminar')}>Eliminar</button>
                </div>
                </div>
            )})}
            </div>
        </div>
        
        {popUpof ? (<>
        <div className={'contofUH'} >
        <div className={'OF_UHPop'} >
            <div onClick={() => setPopUpof(!popUpof)} id='back-button'><img src={regr} id="regresar" alt="Regresar"/></div>
            <h4>Seleccione las canchas a las que <br />
                aplicará la oferta y coloque el precio.</h4>
            <div
            className="grid"
            style={{
                display: 'grid',
                gridTemplateColumns: `1fr ${Object.keys(canfut5).length ? '1fr ' : ''}${Object.keys(canfut7).length ? '1fr ' : ''}${Object.keys(canfut11).length ? '1fr' : ''}`.trim(),
                gap: '10px'
            }}
            >
            {/* Top headers */}
            <div></div>
            {Object.keys(canfut5).length > 0 ? (<div className="header">Fut 5 
                <input input type='checkbox' id={`UHora_5`} checked={Uhora_chkbx.UHora_5} onChange={handleCanchas2}
                style={{margin:"5px"}}/>
            </div>):null}
            {Object.keys(canfut7).length > 0 ? (<div className="header">Fut 7 
                <input input type='checkbox' id={`UHora_7`} checked={Uhora_chkbx.UHora_7} onChange={handleCanchas2}
                style={{margin:"5px"}}/>
            </div>):null}
            {Object.keys(canfut11).length > 0 ? (<div className="header">Fut 11
                <input input type='checkbox' id={`UHora_11`} checked={Uhora_chkbx.UHora_11} onChange={handleCanchas2}
                style={{margin:"5px"}}/>
            </div>):null}

            {/* Rows */}
            {Array.from({ length: maxRows }).map((_, i) => (
                <React.Fragment key={i}>
                <div className="cell bold">
                    {canfut5[i]?.nombre || canfut7[i]?.nombre || canfut11[i]?.nombre || ''}
                </div>
                {Object.keys(canfut5).length > 0 ? (<div className="cell"> {canfut5[i]?.id ? (<input type='number' value={UHinfo[canfut5[i].id]?.Precio} 
                style={{width:'50px'}} disabled={!Uhora_chkbx.UHora_5} onChange={cinUHof} id={canfut5[i]?.id || ''}/>) : null} </div>):null}
                {Object.keys(canfut7).length > 0 ? (<div className="cell"> {canfut7[i]?.id ? (<input type='number' value={UHinfo[canfut7[i].id]?.Precio} 
                style={{width:'50px'}} disabled={!Uhora_chkbx.UHora_7} onChange={cinUHof} id={canfut7[i]?.id || ''}/>) : null} </div>):null}
                {Object.keys(canfut11).length > 0 ? (<div className="cell"> {canfut11[i]?.id ? (<input type='number' value={UHinfo[canfut11[i].id]?.Precio} 
                style={{width:'50px'}} disabled={!Uhora_chkbx.UHora_11} onChange={cinUHof} id={canfut11[i]?.id || ''}/>) : null} </div>):null}               
                </React.Fragment>
            ))}
            </div>
            <button onClick={crearOfUH} className='ConfOfUH'>Confirmar</button>
            </div></div>
        </>):null}
    </div>
  )
}

export default Ofertas